import React from "react";
import {Form, Button, Input, message} from "antd";
import {apiMethods} from "../../controller/Request";
import {Config} from "../../controller/Global";

const FormItem = Form.Item;

class ChangePassword extends React.Component {
    state = {
        confirmDirty: false,
        loading: false
    };
    compareToPrevPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('Two passwords that you enter is inconsistent!');
        } else {
            callback();
        }
    };
    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm_password'], {force: true});
        }
        else if(value && value === form.getFieldValue('old_password')){
            callback("New Password should not same as old password")
        }
        callback();
    };
    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({confirmDirty: this.state.confirmDirty || !!value});
    };

    handleSubmit = () => {
        const {form} = this.props;
        form.validateFields((err, values) => {
            if (!err) {
                this.setState({loading: true});
                const URL = Config['api']['auth']['change_password'];
                apiMethods.post(URL, JSON.stringify(values), true)
                    .then(() => {
                        form.resetFields();
                        this.setState({loading: false});
                    })
                    .catch(error => {
                        this.setState({loading: false});
                    })
            }
        })
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {loading} = this.state;
        return (
            <React.Fragment>
                <div className="row mb-4">
                    <div className="col-sm-4 col-12">
                        <FormItem label="Old Password">
                            {getFieldDecorator('old_password', {
                                rules: [{required: true, message: 'Old password required'}],
                            })(<Input type="password" placeholder="Enter Old Password"/>)}
                        </FormItem>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-sm-4 col-12">
                        <FormItem label="New Password">
                            {getFieldDecorator('password', {
                                rules: [{required: true, message: 'New password required'},
                                    {validator: this.validateToNextPassword}],
                            })(<Input type="password" placeholder="New Password"/>)}
                        </FormItem>
                    </div>
                </div>
                <div className="row mb-4">
                    <div className="col-sm-4 col-12">
                        <FormItem label="Confirm Password">
                            {getFieldDecorator('confirm_password', {
                                rules: [{required: true, message: 'Confirm password required'},
                                    {validator: this.compareToPrevPassword}],
                            })(<Input type="password" placeholder="Confirm Password" onBlur={this.handleConfirmBlur}/>)}
                        </FormItem>
                    </div>
                </div>
                <div className="row pt-3">
                    <div className="col-12">
                        <Button type='primary' htmlType="button" loading={loading} onClick={this.handleSubmit}>Save</Button>
                    </div>
                </div>
            </React.Fragment>

        )
    }
}

export const ChangePasswordForm = Form.create()(ChangePassword);


// WEBPACK FOOTER //
// ./src/pages/settings/ChangePassword.jsx